/**
* menu-list JS
* -----------------------------------------------------------------------------
*
* All the JS for the menu-list component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'menu-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'menu-list', COMPONENT );
} )( app );
